/**
 * 公共方法
 */
import axios from 'axios'
import store from '@/store'
import {MessageBox} from 'element-ui'
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000, // request timeout
  withCredentials: true //使前台能够保存cookie
})

service.interceptors.request.use(config => {
  if (store.getters.getSessionId) {
    config.headers.common['Authorization'] = store.getters.getSessionId
  }
  config.withCredentials = true;
  return config
}, error => {
  console.log(error)
})

//定义一个响应拦截器
service.interceptors.response.use(config => {
//在这里对返回的数据进行处理
  if(config.data.code == 403){
     alert('填写参数有误');
  }
  return config
},error => {
  if(location.pathname == "/login"){
    console.log("系统异常");
  }else{
    /* MessageBox("系统异常,请重新登录", "提示", {
      confirmButtonText: '确定'
    });
    sessionStorage.clear();
    window.location.href = location.href; */
  }
})
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js